import { useState } from 'react';
import * as S from './styles';
import { moeda } from '../funcoes';
import { Borda } from './components/Borda';
import { LineData } from './components/LineData/LineData';
import { IMAGES_PATH } from '../../utils/imagesPath';

function CardProduto({ data }) {
  const [imgError, setImgError] = useState(false);
  const montagem = JSON.parse(data?.Montagem || '[]').length
    ? JSON.parse(data.Montagem)
    : [];
  const sabores = JSON.parse(data?.Sabores || '[]').length
    ? JSON.parse(data.Sabores)
    : [];
  const adicionais = JSON.parse(data?.Adicionais || '[]').length
    ? JSON.parse(data.Adicionais)
    : [];

  const totalMontagemPrice = montagem.reduce(
    (acc, mont) => acc + (+mont.precoMontagem || 0),
    0,
  );
  const totalAdicionaisPrice = adicionais.reduce(
    (acc, add) => acc + (+add.preco || 0),
    0,
  );
  const borderPrice = data?.IdBorda ? +data.BordaPreco : 0;

  return (
    <S.Container>
      {data.Imagem && !imgError && (
        <S.ProductImage
          alt={data.Descricao}
          src={`${IMAGES_PATH}${data.Imagem}`}
          onError={() => setImgError(true)}
        />
      )}
      <S.Content>
        <h6>{data.Descricao}</h6>

        {data.Tamanho !== null && data.Tamanho !== '' && data.IsPizza && (
          <LineData description={data.Tamanho} label="Tamanho" />
        )}
        {data.Tamanho !== null &&
          data.Tamanho !== '' &&
          data.TipoProduto === 'PREPARADO' &&
          !data.IsPizza && (
            <LineData description={data.Tamanho} label="Tamanho" />
          )}

        {montagem.map((mont) =>
          mont.quantidade > 0 ? (
            <LineData
              key={mont.DescricaoMontagem}
              label={mont.DescricaoMontagem}
              description={mont.label}
              price={mont?.precoMontagem}
              quantity={mont.quantidade}
            />
          ) : null,
        )}

        {sabores.map((sabor, index) =>
          sabor.check ? (
            <LineData
              key={sabor.label}
              label={`Sabor ${index + 1}`}
              description={sabor.label}
            />
          ) : null,
        )}

        {data?.IdBorda && <Borda data={data} />}

        {adicionais.map((addittional) =>
          addittional.check ? (
            <LineData
              key={addittional.label}
              label="Adicional"
              description={addittional.label}
              price={addittional.preco}
              quantity={addittional.amount}
            />
          ) : null,
        )}

        {data?.Observacao && (
          <LineData label="Observacao" description={data.Observacao} />
        )}

        <S.PriceRow>
          <S.SubPrice>{`Valor Produto${+data.Quantidade > 1 ? 's' : ''}`}</S.SubPrice>
          <S.SubPrice>
            {data.Valor && `${moeda(+data.Valor * +data.Quantidade)}`}
          </S.SubPrice>
        </S.PriceRow>

        <S.PriceRow>
          <S.Price>
            {moeda(
              (+data.Valor +
                totalMontagemPrice +
                totalAdicionaisPrice +
                borderPrice) *
                +data.Quantidade,
            )}
          </S.Price>
          <S.Quantity>{+data.Quantidade} UN</S.Quantity>
        </S.PriceRow>
      </S.Content>
    </S.Container>
  );
}

export default CardProduto;
